import React, { useContext, useEffect, useRef, useState } from "react";
import { graphql, navigate, useStaticQuery, withPrefix } from "gatsby";
import Slider from "react-slick";

// Components //
import SelectRecommendedTopics from "../../molecules/select-recommended-topics/SelectRecommendedTopics";
import MediaCardLite from "../../molecules/media-card-lite/MediaCardLite";
import MediaCard from "../../molecules/media-card/mediaCard";
import TitleSection from "../../molecules/title-section";
import rawToReact from "../../../utils/rawToReact";
import Button from "../../atoms/button/button";
import Modal from "../../ui/modal/Modal";
import NoContentMessage from "../../molecules/no-content-message/noContentMessage";

// Styles //
import "./RecommendedContentCompanies.scss";

// Context //
import GlobalContext from "../../../contexts/globalContext";

const RecommendedContentCompanies = (props: any) => {

    const contenidoBibliotecas = useStaticQuery(graphql`
    query QUERY_BIBLIOTECAS_EMPRESAS {
        bibliotecaEmpresas: allContentfulSubcategorias(
            filter: {contentful_id: {eq: "375byUYeLcAQQ0m8BX1vLf"}}
          ) {
            nodes {
              referenciaSubcategorias {
                titulo
                slug
                referenciaSubcategorias {
                  slug
                  referenciaInterna {
                    referenciaContenido {
                      referenciaMultimedia {
                        tituloMultimedia
                        textoIntroductorio
                        tematica
                        categoriaMultimedia
                        imagenPrincipal 
                        {
                            gatsbyImageData(
                                layout: CONSTRAINED
                                outputPixelDensities: [0.5, 1, 2]
                                breakpoints: [320, 768, 1024, 1440]
                                placeholder: BLURRED
                                sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                            )
                            description
                        }
                        tituloBoton
                      }
                    }
                  }
                }
              }
            }
          }
          bibliotecaComunidades: allContentfulSubcategorias(
            filter: {contentful_id: {eq: "2SmuRXdJp2FuOoTdiVoL5D"}}
          ) {
            nodes {
              referenciaSubcategorias {
                titulo
                slug
                referenciaInterna {
                  referenciaContenido {
                    referenciaMultimedia {
                        tituloMultimedia
                        textoIntroductorio
                        tematica
                        categoriaMultimedia
                        imagenPrincipal {
                                gatsbyImageData(
                                    layout: CONSTRAINED
                                    outputPixelDensities: [0.5, 1, 2]
                                    breakpoints: [320, 768, 1024, 1440]
                                    placeholder: BLURRED
                                    sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                )
                            }
                        tituloBoton
                    }
                  }
                }
              }
            }
          }
        eventosEmpresas: allContentfulSubcategorias(
            filter: {contentful_id: {eq: "3lu1VnDLUxgwv9h7HwEJFj"}}
          ) {
            nodes {
              referenciaSubcategorias {
                titulo
                slug
                referenciaInterna {
                  referenciaContenido {
                    referenciaEventos {
                        titulo
                        tituloEvento
                        lugarEvento
                        horaEvento
                        fechaEvento
                        tituloBoton
                        imagenPrincipal {
                                gatsbyImageData(
                                    layout: CONSTRAINED
                                    outputPixelDensities: [0.5, 1, 2]
                                    breakpoints: [320, 768, 1024, 1440]
                                    placeholder: BLURRED
                                    sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                )
                                description
                            }
                        modoEvento
                        tipoEvento
                        requiereInscripcion
                    }
                  }
                }
              }
            }
          }
          modalRestrictedContent: allContentfulContactenos(
            filter: { contentful_id: { eq: "2GQd9tOCLV7wNQ2AClRrmy" } }
        ) {
            nodes {
                tituloPrincipal
                descripcionFormulario {
                    raw
                }
                descripcion {
                    raw
                }
                metaTitulo
                imagenFormulario {
                    file {
                        url
                    }
                }
                tituloBoton
                redireccionBoton
            }
        }
        noContentEmpresas: contentfulPlantillaContenido(contentful_id: {eq: "BC75RgxlmLYMaMURxeNNn"}) {
            tituloBanner
            descripcion {
                raw
            }
            imagenPrincipal
            {
                gatsbyImageData(
                    layout: CONSTRAINED
                    outputPixelDensities: [0.5, 1, 2]
                    breakpoints: [320, 768, 1024, 1440]
                    placeholder: BLURRED
                    sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                )
                description
            }
        }
      }
`);

    const comunidadesData = contenidoBibliotecas.bibliotecaComunidades.nodes[0].referenciaSubcategorias
    const eventosEmpresasData = contenidoBibliotecas.eventosEmpresas.nodes[0].referenciaSubcategorias
    const empresasData = contenidoBibliotecas.bibliotecaEmpresas.nodes[0].referenciaSubcategorias
    const modalRestrictedContent = contenidoBibliotecas.modalRestrictedContent.nodes[0]

    const [hasCommunityAccess, setHasCommunityAccess] = useState<boolean>(false);
    const [oportunidadesContent, setOportunidadesContent] = useState<any[]>([]);
    const [categoriesFromModal, setCategoriesFromModal] = useState([]);
    const [restrictedContent, setRestrictedContent] = useState(false);
    const [ofrecemosContent, setOfrecemosContent] = useState<any[]>([]);
    const [empresasContent, setEmpresasContent] = useState([]);
    const [sliderNovedades, setSliderNovedades] = useState<Slider | null>(null);
    const [publicacionesRecientes, setInteresContent] = useState<any[][]>([]);
    const [displayModal, setDisplayModal] = useState(false);
    const [indexNovedades, setIndexNovedades] = useState(0);
    const [sliderIndex, setSliderIndex] = useState(0);
    const [loaded, setLoaded] = useState(true);
    const [slider, setSlider] = useState<Slider | null>(null);

    const Context = useContext(GlobalContext);

    // Configuracion para el slider De tu interes
    const tendenciasCarousel = {
        className: 'slider-tendencias',
        customPaging: i => (
            <div className={`line line-${i}`}>──</div>
        ),
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        }
    };

    // Configuracion para el slider de Novedades
    const OportunidadesCarousel = {
        className: 'slider-oportunidades',
        customPaging: i => (
            <div className={`line line-${i}`}>──</div>
        ),
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setIndexNovedades(next);
        }
    };

    // Control del index para el slider Interes
    const goToNext = () => {
        if (slider && Array.isArray(slider.props.children) && sliderIndex < slider.props.children.length) {
            setSliderIndex(sliderIndex + 1);
            slider?.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider?.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => Array.isArray(slider?.props.children) && sliderIndex < slider?.props.children.length;

    // Control del index para el slider de Novedades
    const goToNextN = () => {
        if (sliderNovedades && Array.isArray(sliderNovedades.props.children) && indexNovedades < sliderNovedades.props.children.length - 1) {
            setIndexNovedades(indexNovedades + 1);
            sliderNovedades.slickNext();
        }
    };

    const goToBackN = () => {
        if (indexNovedades > 0) {
            setIndexNovedades(indexNovedades - 1);
            sliderNovedades?.slickPrev();
        }
    };

    const isActiveBackN = () => indexNovedades > 0;
    const isActiveNextN = () => Array.isArray(sliderNovedades?.props.children) && indexNovedades < sliderNovedades.props.children.length - 1;

    // Funcion para generar un numero aleatorio entre 0 y maxNumber
    const randomNumber = (maxNumber: number) => {
        return Math.floor(Math.random() * maxNumber);
    }

    const setRandomArticle = (library, setLibrary) => {
        let category = null;
        if (categoriesFromModal.length > 0) {
            // Selecciona una categaria aleatoria de la seleccion del modal temas recomendados
            category = library[categoriesFromModal[randomNumber(categoriesFromModal.length)]]
        } else {
            // Selecciona una categoria aleatoria de las bibliotecas del index 0 hasta el index 4
            category = library[randomNumber(4)]
        }

        // Selecciona un articulo aleatorio de la categoria aleatoria
        const articleSubcategory = category.referenciaSubcategorias[randomNumber(category.referenciaSubcategorias.length)]
        const articleSlug = articleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]

        // Slug para la redireccion del boton
        const libraryType = "/empresas/biblioteca/"
        articleSlug["redireccionBoton"] = libraryType + category.slug + articleSubcategory.slug
        setLibrary(prevContent => [...prevContent, articleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
    }

    const setRandomEvent = () => {
        if(eventosEmpresasData && eventosEmpresasData.length != 0) {
            const randomEventSubcategory = eventosEmpresasData[randomNumber(eventosEmpresasData.length)]
            const randomEvent = randomEventSubcategory.referenciaInterna.referenciaContenido[0].referenciaEventos[0]
            randomEvent["redireccionBoton"] = '/empresas/eventos/' + randomEventSubcategory.slug
            setOportunidadesContent(prevState => [...prevState, randomEvent])
        } else {
            setOportunidadesContent(prevState => [...prevState, null])
        }
    }

    // Redirecciona a la cotenido de la biblioteca comunidades
    const handleIngresaAction = async (slug) => {
        if (Context.gigyaContext.gigyaAccount) {
            hasCommunityAccess ? navigate(slug) : setRestrictedContent(true)
        }
        else {
            Context.gigyaContext.loginComfamaId!();
        }
    }

    const closeModal = () => {
        localStorage.removeItem('selectedRecommendedTopics')
        setDisplayModal(false);
        return false
    };

    // Contenido para los bloques de sliders
    useEffect(() => {

        // Contenido para el bloque 1 de slider 'Publicaciones recientes'
        for (let index = 0; index < 4; index++) {
            setRandomArticle(empresasData, setEmpresasContent)
        }

        // Contenido para el bloque 2 de slider 'Oportunidades para ti'
        for (let index = 0; index < 2; index++) {
            if(index == 0) setRandomEvent()
            // El index de empresasData es la posicion de la subcategoria en el CMS de biblioteca empresas EntryId: 375byUYeLcAQQ0m8BX1vLf
            // Index 5: Categoria Mas de empleo
            // Index 6: Categoria Iniciativas de empleo
            const article = empresasData[index + 5].referenciaSubcategorias[randomNumber(empresasData[index + 5].referenciaSubcategorias.length)]
            article.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]['redireccionBoton'] = '/empresas/biblioteca/' + empresasData[index + 5].slug + article.slug
            setOportunidadesContent(prevState => [...prevState, article.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
        }

        //contenido para el bloque 3 de slider 'Te ofrecemos'
        for (let index = 0; index < 3; index++) {
            const article = comunidadesData[randomNumber(comunidadesData.length)]
            article.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]['redireccionBoton'] = '/empresas/comunidades/accede/biblioteca/' + article.slug
            setOfrecemosContent(prevState => [...prevState, article.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
        }
        return () => {
            setEmpresasContent([])
            setOfrecemosContent([])
            setOportunidadesContent([])
        };
    }, [categoriesFromModal])

    // Contenido para el bloque 1 de slider 'Publicaciones recientes'
    useEffect(() => {
        if (empresasContent)
            setInteresContent([empresasContent])

        if (empresasContent.length > 1 && publicacionesRecientes.length > 1)
            setLoaded(true)
    }, [empresasContent])

    // Agrega el index de las categorias que se van a mostrar en el slider de 'Tendencias mercado laboral'
    // El index esta determinado por el orden de las catergorias en el CMS
    //Los items del local storage son la seleccion de las categorias en el modal "temas recomendados"
    useEffect(() => {
        const indexCategoryList: number[] = []
        const categories: string[] = ['Procesos de selección', 'Gestión de talento', 'Cultura y clima organizacional', 'Herramientas para la selección', 'Inclusión laboral']
        for (let index = 0; index < categories.length; index++) {
            if (!!(localStorage.getItem(categories[index]))) indexCategoryList.push(index);
        }
        setCategoriesFromModal(indexCategoryList as []);
    }, [])

    // Valida si el usuario tiene acceso al contenido de biblioteca comunidades
    useEffect(() => {
        Context?.gigyaContext?.gigyaAccount?.data?.servicesAuth?.forEach((service) => {
            setHasCommunityAccess(service.serviceId == "COMDADEMPL");
        });
    }, [Context.gigyaContext.gigyaAccount])

    useEffect(() => {
        if (localStorage.getItem('selectedRecommendedTopics')) {
            localStorage.setItem("hashSection", "destacadosDeTuInteresEmpresas")
            setDisplayModal(true);
        } else {
            setDisplayModal(false)
            setTimeout(() => {
                localStorage.removeItem('hashSection')
            }, 3000)
        }
    }, [])

    // Referencia el elemento del DOM
    const targetRef = React.useRef (null);
    
    function handleIntersection(entries, observer) {
        const element = document.querySelector('.banner-empresa-headboard-text__logo')
        entries.forEach((entry) => {
        if (entry.isIntersecting) {
            // Entra si el elemento esta en el viewport
            // Estilos para desaparecer el banner
            element ? element.style.visibility = 'hidden' : null
            element ? element.style.opacity = '0' : null
        }
        });
    }
    
    const options = {
        root: null, // Viewport como la raiz
        rootMargin: '0px', // Margin alrededor del viewport
        threshold: 0.1, // Cuando el 10% del target es visible, se activa
    };
    
    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection, options);
        // Punto donde se observa el target element
        if (targetRef.current) {
            observer.observe(targetRef.current);
        }
    
        // Limpia el observer cuando el componente se desmonte
        return () => {
        observer.disconnect();
        };
    }, []);

    return (
        <>
            <div className="o-recommended-content-companies" id={"destacadosDeTuInteresEmpresas"} ref={targetRef}>
                <div className="o-recommended-content-companies-title">
                    <TitleSection title={"Destacados de tu interés"} />
                    <div className="o-recommended-content-companies-title-edit">
                        <button onClick={() => (setDisplayModal(true))}>
                            <svg id="editar_2" data-name="editar" xmlns="http://www.w3.org/2000/svg" width="16.139" height="16.139" viewBox="0 0 16.139 16.139">
                                <path id="Trazado_76460" data-name="Trazado 76460" d="M14.183.64l-8.2,8.2A3.339,3.339,0,0,0,5,11.216v.9a.672.672,0,0,0,.672.672h.9a3.339,3.339,0,0,0,2.377-.984l8.2-8.2a2.1,2.1,0,0,0,0-2.968,2.148,2.148,0,0,0-2.968,0ZM16.2,2.657,8,10.856a2.031,2.031,0,0,1-1.426.59H6.345v-.231a2.031,2.031,0,0,1,.59-1.426l8.2-8.2a.772.772,0,0,1,1.066,0,.755.755,0,0,1,0,1.066Z" transform="translate(-1.638 -0.015)" fill="#ee2b7b" />
                                <path id="Trazado_76461" data-name="Trazado 76461" d="M15.466,6.038a.672.672,0,0,0-.672.672v3.376H12.1A2.017,2.017,0,0,0,10.087,12.1v2.69H3.362a2.017,2.017,0,0,1-2.017-2.017V3.362A2.017,2.017,0,0,1,3.362,1.345h6.08A.672.672,0,1,0,9.442,0H3.362A3.366,3.366,0,0,0,0,3.362v9.414a3.366,3.366,0,0,0,3.362,3.362H10.99a3.341,3.341,0,0,0,2.378-.984l1.786-1.787a3.341,3.341,0,0,0,.985-2.377V6.71A.672.672,0,0,0,15.466,6.038ZM12.417,14.2a2,2,0,0,1-.985.538V12.1a.672.672,0,0,1,.672-.672h2.639a2.028,2.028,0,0,1-.538.984Z" fill="#ee2b7b" />
                            </svg>
                            <p>Editar recomendaciones</p>
                        </button>
                    </div>
                </div>

                <div className="o-recommended-content-companies-section">
                    <div className="o-recommended-content-companies-section-interes">
                        <h3 className="o-recommended-content-companies-section-interes-title">
                            Publicaciones <br /> recientes
                        </h3>
                        <>
                            <div className="o-recommended-content-companies-section-interes-card">
                                <div className="o-recommended-content-companies-section-interes-card-arrows-slider">
                                    <span
                                        className={`arrow icon-chevron-left ${isActiveBack() ? "active" : ""
                                            } gtm_navegar_recientes_atras_empresas`}
                                        onClick={goToBack}
                                    ></span>
                                    <span
                                        className={`arrow  icon-chevron-right  ${isActiveNext() ? "active" : ""
                                        } gtm_navegar_recientes_adelante_empresas`}
                                        onClick={goToNext}
                                    ></span>
                                </div>
                                <Slider ref={(c) => { setSlider(c); }}{...tendenciasCarousel}>
                                    {loaded && publicacionesRecientes.map((cards) => (
                                        cards.map((item, i) => (
                                            <>
                                                <MediaCard
                                                    key={i}
                                                    tituloMultimedia={item.tituloMultimedia}
                                                    descripcion={{
                                                        json: undefined
                                                    }}
                                                    imagenPrincipal={
                                                        item.imagenPrincipal    
                                                    }
                                                    tituloBoton='VER MÁS'
                                                    redireccionBoton={item.redireccionBoton}
                                                    slug={item.redireccionBoton}
                                                    tematica={item.tematica}
                                                    categoriaMultimedia={item.categoriaMultimedia}
                                                    nuevoContenido={false}
                                                    parentContentfulId={props.contentful_id} 
                                                />
                                            </>
                                        ))))}
                                </Slider>
                                <div className="o-recommended-content-companies-section-interes-button">
                                    <Button
                                        classname={`a-button primary restricted-content-modal__button__biblioteca`}
                                        type="link"
                                        text="IR A LA BIBLIOTECA"
                                        href={withPrefix('/empresas/biblioteca/')}
                                        isDisabled={false}
                                    />
                                </div>
                            </div>
                        </>
                    </div>

                    <div className="o-recommended-content-companies-section-novedades">
                        <h3 className="o-recommended-content-companies-section-novedades-title">
                            Oportunidades para ti
                        </h3>
                        <div className="o-recommended-content-companies-section-novedades-card-arrows-slider">
                            <span
                                className={`arrow icon-chevron-left ${isActiveBackN() ? "active" : ""
                                    } gtm_navegar_novedades_atras_empresas`}
                                onClick={goToBackN}
                            ></span>
                            <span
                                className={`arrow  icon-chevron-right  ${isActiveNextN() ? "active" : ""
                                    } gtm_navegar_novedades_adelante_empresas`}
                                onClick={goToNextN}
                            ></span>
                        </div>
                        <Slider ref={(c) => { setSliderNovedades(c); }}{...OportunidadesCarousel}>
                            {loaded && oportunidadesContent.map((item: any, index) => {
                                if(item == null) {
                                    return <NoContentMessage key={index} title={contenidoBibliotecas.noContentEmpresas.tituloBanner} subtitle={contenidoBibliotecas.noContentEmpresas.descripcion} imagenPrincipal={contenidoBibliotecas.noContentEmpresas.imagenPrincipal} className="evento-empresas"/>
                                }
                                return <MediaCard
                                    key={item.redireccionBoton}
                                    tituloMultimedia={item.tituloMultimedia || item.tituloEvento}
                                    textoIntroductorio={item.textoIntroductorio}
                                    descripcion={{
                                        json: undefined
                                    }}
                                    imagenPrincipal={
                                        item.imagenPrincipal    
                                    }
                                    tituloBoton={item.requiereInscripcion ? 'INSCRÍBETE AQUÍ' : "CONOCE MÁS AQUÍ"}
                                    redireccionBoton={item.redireccionBoton}
                                    slug={item.redireccionBoton}
                                    tematica={item.tematica}
                                    categoriaMultimedia={item.categoriaMultimedia || item.tipoEvento}
                                    tituloEvento={item.tituloEvento}
                                    fechaEvento={item.fechaEvento?.split(',')[2] + ', ' + item.fechaEvento?.split(',')[0] + ' de ' + item.fechaEvento?.split(',')[1]}
                                    horaEvento={item.horaEvento}
                                    lugarEvento={item.lugarEvento}
                                    nuevoContenido={false}
                                    parentContentfulId={props.contentful_id} 
                                />
                            })}
                        </Slider>
                    </div>

                    <div className="o-recommended-content-companies-section-ofrecemos">
                        <h3 className="o-recommended-content-companies-section-ofrecemos-title">
                            Comunidades
                        </h3>
                        {loaded && ofrecemosContent.map((item) => (
                            <>
                                <MediaCardLite
                                    key={item.redireccionBoton}
                                    tituloMultimedia={item.tituloMultimedia}
                                    descripcion={{
                                        json: undefined,
                                    }}
                                    imagenPrincipal={
                                        item.imagenPrincipal    
                                    }
                                    tituloBoton='VER MÁS'
                                    tematica={item.tematica}
                                    categoriaMultimedia={item.categoriaMultimedia}
                                    nuevoContenido={false}
                                    onClick={() => { handleIngresaAction(item.redireccionBoton) }}
                                    parentContentfulId={props.contentful_id}
                                />
                            </>
                        ))}
                        <div className="o-recommended-content-companies-section-ofrecemos-button">
                            <Button
                                classname={`a-button primary restricted-content-modal__button gtm_comunidades_destacadosdetuinteres`}
                                type="link"
                                text='IR A COMUNIDADES'
                                href="/servicio-de-empleo/empresas/comunidades/"
                                isDisabled={false}
                            />
                        </div>
                    </div>
                </div>
            </div >

            {displayModal && < SelectRecommendedTopics
                referenciaFormulario={props.referenciaFormulario[0]}
                closeModal={closeModal}
                displayModal={displayModal}
            />}

            {restrictedContent && <Modal showModal={false} onClose={() => setRestrictedContent(false)} >
                <div className="restricted-content-modal">
                    <h2 className="restricted-content-modal__title">
                        {modalRestrictedContent.tituloPrincipal}
                    </h2>
                    <p className="restricted-content-modal__description">{rawToReact(modalRestrictedContent.descripcionFormulario.raw)}</p>
                    <Button
                        classname={`a-button__magenta restricted-content-modal__button gtm_unetecomunidad_destacadosempresas`}
                        type="link"
                        text={modalRestrictedContent.tituloBoton}
                        href="/servicio-de-empleo/empresas/comunidades/unete/"
                        isDisabled={false}
                    />
                </div>
            </Modal >}
        </>
    );
};

export default RecommendedContentCompanies;
